type HeadingMap = {
  project(coordinate: [number, number]): { x: number; y: number };
  getBearing(): number;
};

// Project a short compass-heading segment so pitch and bearing both affect
// the icon exactly as they affect the road beneath it. Labels stay upright.
export function screenVehicleHeading(map: HeadingMap, coordinate: [number, number], heading: number): number {
  const radians = heading * Math.PI / 180;
  const [lng, lat] = coordinate;
  const step = 0.00001;
  const next: [number, number] = [
    lng + Math.sin(radians) * step / Math.max(0.000001, Math.cos(lat * Math.PI / 180)),
    lat + Math.cos(radians) * step,
  ];
  const a = map.project(coordinate);
  const b = map.project(next);
  const dx = b.x - a.x;
  const dy = b.y - a.y;
  if (!Number.isFinite(dx + dy) || Math.hypot(dx, dy) < 1e-9) return heading - map.getBearing();
  return Math.atan2(dx, -dy) * 180 / Math.PI;
}
